<template>
  <nav class="sc-tabs" role="tablist">
    <button
      v-for="(tab, index) in tabs"
      v-show="tab.isShow"
      :key="tab.name"
      :class="{ active: currentTab.name === tab.name, error: errorTabs[index] }"
      :aria-selected="currentTab.name === tab.name ? 'true' : 'false'"
      type="button"
      role="tab"
      class="sc-tab"
      @click="changeTab(tab)"
    >
      {{ tab.name }}
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: Object,
      default: null,
    },
    errorTabs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentTab() {
      return this.activeTab || this.tabs[0];
    },
    tabs() {
      const isNews = this.$route.params.articleType === "news";
      return [
        { name: "เนื้อหาข่าว", isShow: true },
        { name: "รายละเอียดกิจกรรม", isShow: !isNews },
        { name: "ส่งถึงใคร", isShow: true }
      ];
    }
  },
  methods: {
    changeTab(to) {
      this.$emit("change:article-tab", to);
    }
  }
};
</script>

<style scoped>
/* Strip only the native <button> UA styles; sizing, spacing, colors, and the
   active underline still come from the global .sc-tab theme in
   assets/scss/globals/index.scss — don't reset those here or they override it. */
.sc-tab {
  appearance: none;
  background: none;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  /* App.vue styles bare <button> globally (border-radius: 12px; padding: 6px 20px;)
     — flatten those so the theme underline stays a straight line */
  border-radius: 0;
  padding-top: 0;
  padding-right: 0;
  padding-left: 0;
  font-family: inherit;
  text-align: inherit;
}
</style>
